import {
  Box,
  Flex,
  SimpleGrid,
} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {testWorlds} from '../../helpers/testWorldsJc';
import {useLobbyHelp} from '../../hooks/useLobbyHelp';
import {useVuplex} from '../../hooks/useVuplex';
import {helpStepSet, userIdsBlockedByUserSet, worldsSet} from '../../reducers/worldsReducer';
import {
  sendBlockedUserIdsRequest,
  sendWorldCreate,
  sendWorldsRequest,
} from '../../vuplex';
import PageTitle from './PageTitle';
import BackToSoloWorldCard from './WorldsSpaceport/BackToSoloWorldCard';
import BrowseModal from './WorldsSpaceport/BrowseModal';
import ConfirmModal from './WorldsSpaceport/ConfirmModal';
import {worldTypes} from './WorldsSpaceport/config';
import NewWorldModal from './WorldsSpaceport/NewWorldModal';
import WorldsSpaceportColumn from './WorldsSpaceport/WorldsSpaceportColumn';

const WorldsSpaceport = () => {
  const dispatch = useDispatch();
  const currentWorld = useSelector(s => s.inApp.world) || {};

  const worlds = useSelector(s => s.worlds.worlds);
  // const worlds = testWorlds;
  const spaceportWorlds = worlds.filter(w => w.rules?.worldType === worldTypes.spaceport && w._id !== currentWorld._id);
  const craterRunWorlds = worlds.filter(w => w.rules?.worldType === worldTypes.craterRun && w._id !== currentWorld._id);

  const isSoloWorld = currentWorld.rules?.worldType === worldTypes.soloDressingRoom;

  useVuplex({
    blockedUsers: ({blockedUserIds}) => {
      dispatch(userIdsBlockedByUserSet(blockedUserIds));
    },
    lobbyHelp: ({helpStep}) => {
      dispatch(helpStepSet(helpStep));
    },
    worldList: ({worlds}) => {
      dispatch(worldsSet(worlds));
    },
  });

  useEffect(() => {
    document.body.style.background = 'none';
    sendBlockedUserIdsRequest();
    sendWorldsRequest();
    const intervalId = setInterval(sendWorldsRequest, 5000);
    return () => clearInterval(intervalId);
  }, []);

  useLobbyHelp(3);

  const [joinWorld, setJoinWorld] = useState(null);
  const [browseWorldType, setBrowseWorldType] = useState(null);
  const [newWorldType, setNewWorldType] = useState(null);
  const handleWorldClick = (world) => {
    setBrowseWorldType(null);
    setJoinWorld(world);
  };
  const handleNewWorldClick = (worldType) => {
    setBrowseWorldType(null);
    setNewWorldType(worldType);
  };
  const worldsByType = {
    [worldTypes.craterRun]: craterRunWorlds,
    [worldTypes.spaceport]: spaceportWorlds,
  };
  const isModalOpen = joinWorld || browseWorldType || newWorldType;

  return (
    <>
      <PageTitle title="WorldsSpaceport - Jetpack Clankers"/>

      {/*{!isSoloWorld && (*/}
      {/*  <Flex gap={2} p={0} marginBottom={2}>*/}
      {/*    <Box opacity={isModalOpen ? 0.3 : 1}>*/}
      {/*      <BackToSoloWorldCard*/}
      {/*        onClick={() => {*/}
      {/*          sendWorldCreate({*/}
      {/*            worldType: worldTypes.soloDressingRoom,*/}
      {/*          });*/}
      {/*        }}*/}
      {/*      />*/}
      {/*    </Box>*/}
      {/*  </Flex>*/}
      {/*)}*/}

      <SimpleGrid
        alignItems="stretch"
        bgGradient={null}
        bg={null}
        borderRadius="none"
        columns={2}
        // h={!isSoloWorld ? 'calc(100vh - 6.5em)' : 'calc(100vh - 1rem)'}
        h="100vh"
        overflow="hidden"
        rowGap={2}
        spacing={6}
        p={0}
        position="relative"
        opacity={isModalOpen ? 0.3 : 1}
      >
        <WorldsSpaceportColumn
          currentWorld={currentWorld}
          currentWorldType={currentWorld.rules?.worldType}
          onBrowse={setBrowseWorldType}
          onNewWorldClick={handleNewWorldClick}
          onWorldClick={handleWorldClick}
          worldType={worldTypes.spaceport}
          worlds={spaceportWorlds}
        />

        <WorldsSpaceportColumn
          currentWorld={currentWorld}
          currentWorldType={currentWorld.rules?.worldType}
          onBrowse={setBrowseWorldType}
          onNewWorldClick={handleNewWorldClick}
          onWorldClick={handleWorldClick}
          worldType={worldTypes.craterRun}
          worlds={craterRunWorlds}
        />
      </SimpleGrid>

      <ConfirmModal onClose={() => setJoinWorld(null)} world={joinWorld}/>
      <BrowseModal
        isOpen={!!browseWorldType}
        onClose={() => setBrowseWorldType(null)}
        onNewWorldClick={handleNewWorldClick}
        onWorldClick={handleWorldClick}
        worldType={browseWorldType}
        worlds={worldsByType[browseWorldType] || []}
      />
      <NewWorldModal onClose={() => setNewWorldType(null)} isOpen={!!newWorldType} worldType={newWorldType}/>
    </>
  );
};

export default WorldsSpaceport;
